<!-- @if (isfotter) {
<div class="footer">
  <div class="first-block">
    <img class="img-f" src="/assets/icons/handshake.png" alt="" srcset="">
  </div>
  @if (configuration.configuration?.referral?.name) {
    <p>
        @if(configuration.configuration?.referral?.landings?.market_25){
          <span>
            {{ 'footerReferal.txtMaster' | translate }} <span class="on-boarding-game-user-master">{{configuration.configuration?.referral?.name}}</span>{{ 'footerReferal.txtLive' | translate }}
            <a href="{{configuration.configuration?.referral?.landings?.market_eu}}" class="on-boarding-game-countri-es" target="_blank">{{ 'footerReferal.txtEU' | translate }}</a>&nbsp;<a href="{{configuration.configuration?.referral?.landings?.market_25}}" class="on-boarding-game-countri-not-es" target="_blank">{{ 'footerReferal.txtNonEu' | translate }}</a>
          </span>
        }
        @if(configuration.configuration?.referral?.landings?.referal_link){
          <span>
            {{ 'footerReferal.txtMaster' | translate }} <span class="on-boarding-game-user-master">{{configuration.configuration?.referral?.name}}</span>{{ 'footerReferal.txtUse' | translate }}
            <a href="{{configuration.configuration?.referral?.landings?.referal_link}}" class="on-boarding-game-countri-es" target="_blank">{{ 'footerReferal.txtLink' | translate }}</a>&nbsp;{{ 'footerReferal.txtRegis' | translate }}
          </span>
        }
    </p>
  } @else {
    <p >
      {{ 'footer.txtFooter' | translate  }}
    </p>
  }
  
  <div class="button-close" (click)="closeReferal()">
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
  </div>
</div>
} @else if(!isfotter) {
<div class="footer-button" (click)="closeReferal()">
  <img class="img" src="/assets/icons/handshake.png" alt="" srcset="">
  <img class="hover-img" src="/assets/icons/handshake-hover.png" alt="" srcset="">
</div>
} -->

<div class="fab-container" [class.open]="isOpen">
  <!-- Sub-menu buttons that slide out -->
  <div class="fab-options">
    <p mat-fab>
      @if (configuration.configuration?.referral?.name) {        
            @if(configuration.configuration?.referral?.landings?.market_25){
              <span>
                {{ 'footerReferal.txtMaster' | translate }}&nbsp;<span class="on-boarding-game-user-master">{{configuration.configuration?.referral?.name}}</span><span>{{ 'footerReferal.txtLive' | translate }}</span>
                &nbsp;<mat-icon fontIcon="open_in_new" aria-hidden="false" aria-label="Example thumbs up SVG icon"></mat-icon>&nbsp;<a href="{{configuration.configuration?.referral?.landings?.market_eu}}" class="on-boarding-game-countri-es" target="_blank">{{ 'footerReferal.txtEU' | translate }}</a>&nbsp;<mat-icon fontIcon="open_in_new" aria-hidden="false" aria-label="Example thumbs up SVG icon"></mat-icon>&nbsp;<a href="{{configuration.configuration?.referral?.landings?.market_25}}" class="on-boarding-game-countri-not-es" target="_blank">{{ 'footerReferal.txtNonEu' | translate }}</a>
              </span>
            }
            @if(configuration.configuration?.referral?.landings?.referal_link){
              <span>
                {{ 'footerReferal.txtMaster' | translate }}&nbsp;<span class="on-boarding-game-user-master">{{configuration.configuration?.referral?.name}}</span><span>{{ 'footerReferal.txtUse' | translate }}</span>
                &nbsp;<mat-icon fontIcon="open_in_new" aria-hidden="false" aria-label="Example thumbs up SVG icon"></mat-icon>&nbsp;<a href="{{configuration.configuration?.referral?.landings?.referal_link}}" class="on-boarding-game-countri-es" target="_blank">{{ 'footerReferal.txtLink' | translate }}</a>&nbsp;{{ 'footerReferal.txtRegis' | translate }}
              </span>
            }
            @if(!configuration.configuration?.referral?.landings?.referal_link && !configuration.configuration?.referral?.landings?.market_25){
              @if(!configuration.configuration?.config.show_ext_links){
                <!-- @if(!configuration.configuration?.referral?.landings){ -->
                  <span>
                    {{ 'footerReferal.txtRegister' | translate }}&nbsp;<mat-icon fontIcon="open_in_new" aria-hidden="false" aria-label="Example thumbs up SVG icon"></mat-icon>&nbsp;<a [href]="linkNotreferal" class="on-boarding-game-countri-es" target="_blank">{{ 'footerReferal.txtMLMSystem' | translate }}</a>&nbsp;<span>{{ 'footerReferal.txtStruct' | translate }}&nbsp;Владимир Горбачев</span>
                  </span>
                <!-- } -->
              }@else{
                <!-- @if(!configuration.configuration?.referral?.landings?.referal_link || !configuration.configuration?.referral?.landings?.market_25){ -->
                  <span>
                    {{ 'footerReferal.txtMaster' | translate }}&nbsp;<span class="on-boarding-game-user-master">{{configuration.configuration?.referral?.name}}</span><span>{{ 'footerReferal.txtUse' | translate }}</span>
                    &nbsp;<mat-icon fontIcon="open_in_new" aria-hidden="false" aria-label="Example thumbs up SVG icon"></mat-icon>&nbsp;<a href="{{configuration.configuration?.referral?.landings}}" class="on-boarding-game-countri-es" target="_blank">{{ 'footerReferal.txtLink' | translate }}</a>&nbsp;{{ 'footerReferal.txtRegis' | translate }}
                  </span>
                <!-- } -->
              }
            }
        
      }@else{
        <span>
          {{ 'footerReferal.txtRegister' | translate }}&nbsp;<mat-icon fontIcon="open_in_new" aria-hidden="false" aria-label="Example thumbs up SVG icon"></mat-icon>&nbsp;<a [href]="linkDemo" class="on-boarding-game-countri-es" target="_blank">{{ 'footerReferal.txtMLMSystem' | translate }}</a>&nbsp;<span>{{ 'footerReferal.txtCreateSruct' | translate }}</span>
        </span>
      }
    </p>
    @if(settings.isProduction === 'development'){
      <p mat-fab>
        <span>
          {{ 'footerReferal.txtOtherInfo' | translate }} {{ 'footerReferal.txtOtherInfo' | translate }}
        </span>
      </p>
    }
    <!-- <button mat-mini-fab color="basic" (click)="isOpen = false">
      <mat-icon>print</mat-icon>
    </button> -->
  </div>

  <!-- Primary Trigger FAB Button -->
  <button mat-fab color="primary" (click)="toggleMenu()">
    <mat-icon>{{ isOpen ? 'cancel' : 'handshake' }}</mat-icon>
  </button>
</div>